'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export type Language = {
  name: string;
  slug: string;
};

type LanguageSelectorSimpleProps = {
  currentLang: string;
  languages: Language[];
  onLanguageClick: (lang: string) => void;
};

export function LanguageSelectorSimple({
  currentLang,
  languages,
  onLanguageClick,
}: LanguageSelectorSimpleProps) {
  return (
    <div className='flex gap-2 items-center' data-testid='language-selector-ui-home'>
      {languages.map((lang) => {
        const isActive = lang.slug === currentLang;
        const displayText = lang.slug === 'ru' ? 'РУ' : lang.slug.toUpperCase();

        return (
          <React.Fragment key={lang.slug}>
            <button
              onClick={() => onLanguageClick(lang.slug)}
              className={cn(
                'px-0.5 text-base leading-6 font-normal transition-colors text-black',
                isActive ? 'underline underline-offset-4' : 'no-underline hover:underline hover:underline-offset-4'
              )}
              aria-label={`Switch to ${lang.name}`}
              aria-current={isActive ? 'true' : undefined}
            >
              {displayText}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
